import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import { BalanceSheetDensity } from '../../BalanceSheetTable.types';
import { useBalanceSheetSectionHeaderStyles } from './BalanceSheetSectionHeader.styles';
export interface BalanceSheetSectionHeaderProps {
  /**
   * Section header text (will be displayed in uppercase)
   */
  text: string;
  /**
   * Density setting affecting padding
   */
  density: BalanceSheetDensity;
  /**
   * Whether this is in a presentation context (grayscale colors)
   */
  isPresentation?: boolean;
}

/**
 * BalanceSheetSectionHeader renders a section divider header for the balance sheet table.
 *
 * Section headers are used to separate major categories (e.g., "ASSETS", "LIABILITIES").
 * Text is displayed in uppercase with a 2px bottom border.
 */
export function BalanceSheetSectionHeader(t0) {
  const $ = _c(15);
  const {
    text,
    density,
    isPresentation: t1
  } = t0;
  const isPresentation = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== density || $[1] !== isPresentation) {
    t2 = {
      density,
      isPresentation
    };
    $[0] = density;
    $[1] = isPresentation;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    classes
  } = useBalanceSheetSectionHeaderStyles(t2);
  let t3;
  if ($[3] !== classes.text || $[4] !== text) {
    t3 = <Box component="span" className={classes.text}>{text}</Box>;
    $[3] = classes.text;
    $[4] = text;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== classes.content || $[7] !== t3) {
    t4 = <Box className={classes.content}>{t3}</Box>;
    $[6] = classes.content;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== classes.sectionHeader || $[10] !== t4) {
    t5 = <Box className={classes.sectionHeader}>{t4}</Box>;
    $[9] = classes.sectionHeader;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== classes.root || $[13] !== t5) {
    t6 = <Box className={classes.root}>{t5}</Box>;
    $[12] = classes.root;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}